var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.getMessages[0].message),expression:"getMessages[0].message"}],attrs:{"id":"interface-message"},on:{"click":function($event){return _vm.hide()}}},[_c('div',{staticClass:"message"},[_vm._v("\n\t\t"+_vm._s(_vm.getMessages[0].message)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }